module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/round_stool_256_bake.png";